import React from 'react';

export const name = 'flag-SI';

export const FlagSI = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_412)">
      <mask
        id="mask0_2_412"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_412)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M23.25 7.82809H10.4391V4.69684H4.17188V7.82809H0.75C-0.250549 10.5194 -0.250549 13.4806 0.75 16.1718L12 17.2172L23.25 16.1718C24.2501 13.4805 24.2501 10.5194 23.25 7.82809Z"
          fill="#0052B4"
        />
        <path
          d="M12 24C14.4501 23.9997 16.8414 23.2494 18.8525 21.85C20.8636 20.4506 22.3982 18.4691 23.25 16.1719H0.75C1.60179 18.4691 3.13636 20.4506 5.14748 21.85C7.15861 23.2494 9.54989 23.9997 12 24Z"
          fill="#D80027"
        />
        <path
          d="M4.17188 7.82816V8.86879C4.17188 11.2641 7.30313 12 7.30313 12C7.30313 12 10.4344 11.2641 10.4344 8.86879V7.82816L9.38906 8.86879L7.30313 7.30316L5.21719 8.86879L4.17188 7.82816Z"
          fill="#EEEEEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_412">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
